<template>
  <div class="about-us">
    <div v-if="$i18n.locale == 'fr'">
      <BaseModal>
        <template v-slot:modalheader>
          <p class="title is-4">
            {{ $t("about.title") }}
          </p>
        </template>
        <template v-slot:modalbody>
          <p>
            <a
              target="_blank"
              rel="noopener"
              href="https://perle-bizpal.ca/fr/a-propos/"
              >PerLE</a
            >
            - Services ouverts est une approche novatrice pour concevoir,
            développer et offrir des services en ligne. Services ouverts a pour
            objectif de fournir une méthode de partage efficace et puissante
            ainsi que d’exploiter des services centrés sur le client pour aider
            les entreprises clientes canadiennes, peu importe où ils vont pour
            accéder leurs informations et services.
          </p>
          <p>
            Le but de Services ouverts est de mettre des caractéristiques et des
            fonctionnalités centrés sur le client du service
            <a target="_blank" rel="noopener" href="https://perle-bizpal.ca"
              >PerLE-BizPaL.ca</a
            >
            à la disposition de d’autres organisations intermédiaires tel que
            les associations, les institutions financières, le milieu
            universitaire et les autres ordres de gouvernements. En partageant
            notre travail, nous espérons réduire le chevauchement des efforts,
            tout en améliorant collectivement nos services centrés sur le client
            à l'appui des petites et moyennes entreprises (PME) canadiennes.
          </p>
          <p>
            Les principes qui sous-tendent les Services ouverts sont similaire à
            ceux des
            <a
              target="_blank"
              rel="noopener"
              href="https://ouvert.canada.ca/fr/principes-de-donnees-ouvertes"
              >Données ouvertes du Gouvernement du Canada</a
            >.
          </p>
          <p>
            Les services vont inclure :
          </p>
          <ul>
            <li>une licence pour la réutilisation et la redistribuation;</li>
            <li>
              une note de bas de page décrivant la méthodologie de la collecte
              des données et offrant un lien à la source fiable qui sera
              disponible pour chaque ensemble de données des Services ouverts.
            </li>
          </ul>

          <p>
            Services ouverts a été conçu pour :
          </p>
          <ul>
            <li>
              entrainer une valeur de création continue pour les fournisseurs de
              service et pour les
              <abbr title="petites et moyennes entreprises">PME</abbr>
              canadiennes
            </li>
            <li>être ouvert, transparent et collaboratif;</li>
            <li>
              utiliser des ensembles de données qui sont fiables et traçables;
            </li>
            <li>se concentrer sur une approche axée sur le service.</li>
          </ul>
          <p>
            Svp, envoyer vos questions / commentaires à
            <a href="mailto:ouverts@perle-bizpal.ca">
              {{ $t("contact.email") }}</a
            >
          </p>
        </template>
        <template v-slot:modalfooter>
          <b-button
            outlined
            type="is-primary"
            :aria-label="$t('message.close_btn')"
            @click="$parent.close()"
          >
            {{ $t("message.close_btn") }}
          </b-button>
        </template>
      </BaseModal>
    </div>
    <div v-else>
      <BaseModal>
        <template v-slot:modalheader>
          <p class="title is-4">
            {{ $t("about.title") }}
          </p>
        </template>
        <template v-slot:modalbody>
          <p>
            <a
              target="_blank"
              rel="noopener"
              href="https://bizpal-perle.ca/en/about/"
              >BizPaL</a
            >
            - Open Services is an innovative approach to designing, developing
            and delivering online services. Open Services aims to provide an
            effective and powerful method of sharing and leveraging common
            client-centric services to assist Canadian business clients, no
            matter where they go to access their information/services.
          </p>
          <p>
            Open Services’ goal is to make client-centric features and
            functionalities found on
            <a target="_blank" rel="noopener" href="https://bizpal-perle.ca"
              >BizPaL-PerLE.ca</a
            >
            available to other business intermediaries, such as: associations,
            financial institutions, academia, and other levels of government. By
            sharing our work, we hope to reduce duplication in work efforts,
            while collectively improving our client-centric services to support
            Canadian Small and Medium Enterprises (SME).
          </p>
          <p>
            The principals behind Open Services are similar to those of the
            <a
              target="_blank"
              rel="noopener"
              href="https://open.canada.ca/en/open-data-principles"
              >Government of Canada Open Data</a
            >.
          </p>
          <p>
            The services will include:
          </p>
          <ul>
            <li>A free licence for re-use and redistribution.</li>
            <li>
              Every Open Service will contain a footnote describing the data
              harvesting methodology, as well as a link to the authoritative
              source of the data.
            </li>
          </ul>

          <p>
            Open Services was designed to:
          </p>
          <ul>
            <li>
              Drive continuous value creation for service providers and for
              Canadian <abbr title="Small and Medium Enterprises">SMEs</abbr>
            </li>
            <li>Be open, transparent and collaborative</li>
            <li>Use datasets that are both trusted and traceable</li>
            <li>Focus on a service oriented approach</li>
          </ul>
          <p>
            Please send questions / comments to:

            <a href="mailto:open@bizpal-perle.ca"> {{ $t("contact.email") }}</a>
          </p>
        </template>
        <template v-slot:modalfooter>
          <b-button
            outlined
            type="is-primary"
            :aria-label="$t('message.close_btn')"
            @click="$parent.close()"
          >
            {{ $t("message.close_btn") }}
          </b-button>
        </template>
      </BaseModal>
    </div>
  </div>
</template>

<script>
import BaseModal from "@/components/base-components/BaseModal.vue";
export default {
  name: "AboutModal",
  components: {
    BaseModal
  }
};
</script>

<style></style>
